import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { createStyles, withStyles } from '@mui/styles';
import { useSnackbar } from 'notistack';
import RedChip from '../../reusable-component/RedChip';
import GreenChip from '../../reusable-component/GreenChip';
import YellowChip from '../../reusable-component/YellowChip';
import { DateConverter } from '../../utils/DateConverter';
import { deleteEngagementApi } from "../../api's/EngagementApi";
import PaginationFooter from '../../reusable-component/PaginationFooter';
import BasicMenu from '../../reusable-component/BasicMenu';
import LoadingIcon from '../../reusable-component/LoadingIcon';
import { getWorkflowByUserGroupAndEngagementIdApi } from "../../api's/WorkflowApi";
import { AuthContext } from '../../context/AuthProvider';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    background: 'none !important',
    color: '#8798AD',
    padding: '10px',
    textTransform: 'uppercase',
    fontSize: 12,
    fontWeight: 600,
    textAlign: 'center',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: '15px',
    textAlign: 'center',
  },
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      border: '1px solid red',
      background: '#FFFFFF',
      boxShadow: '0px 2px 6px #0000000A',
      borderRadius: '5px !important',
    },
  })
)(TableRow);

export default function EngagementTable({
  currentPage,
  tableData,
  fetchTableData,
  search,
  setPage,
  pagination = false,
  totalCount,
}) {
  const { userGroup } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const rowsPerPage = 5;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const navigateToEngagement = async (row) => {
    setLoading(true);
    try {
      const response = await getWorkflowByUserGroupAndEngagementIdApi(userGroup, row.engagement_id);
      if (response.status === 200) {
        const path_url = '/engagement/view_details';
        const stateObj = {
          engagement_id: row.engagement_id,
          engagement_name: row.engagement_name,
          client_name: row.client_name,
          domain_name: row.domain_name,
          workflow_count: row.workflow_count,
          workflow_name: row.workflow_name,
          execution_mode: row.execution_mode,
          created_by: row.created_by,
          created_at: row.created_at,
          status: row.status,
        };
        navigate(path_url, {
          state: stateObj,
        });
        sessionStorage.setItem('prev_path', JSON.stringify(path_url));
        sessionStorage.setItem('state_obj', JSON.stringify(stateObj));
      }
    } catch (error) {
      console.log(error);
      if (error.response?.status === 500) {
        enqueueSnackbar('500 Internal Server Error!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else if (error.response?.status === 404) {
        enqueueSnackbar('404 Workflow not found!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Something went wrong!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }
    setLoading(false);
  };

  return (
    <Box>
      <TableContainer>
        <Table
          aria-label="simple table"
          style={{ minWidth: 650, borderSpacing: '0px 10px', borderCollapse: 'separate' }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell>Batch Name</StyledTableCell>
              <StyledTableCell>Client Name</StyledTableCell>
              {/* <StyledTableCell>Engagement Type</StyledTableCell> */}
              <StyledTableCell>Total Workflow</StyledTableCell>
              <StyledTableCell>Created On</StyledTableCell>
              <StyledTableCell>Created By</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage).map((row) => (
              <StyledTableRow key={row.engagement_id}>
                <StyledTableCell>
                  {row.status === 'approved' ? (
                    <Link
                      component="button"
                      variant="body2"
                      onClick={() => {
                        navigateToEngagement(row);
                      }}
                    >
                      {row.engagement_name}
                    </Link>
                  ) : (
                    row.engagement_name
                  )}
                </StyledTableCell>
                <StyledTableCell>{row.client_name}</StyledTableCell>
                {/* <StyledTableCell>{row.engagement_type}</StyledTableCell> */}
                <StyledTableCell>{row.workflow_count}</StyledTableCell>
                <StyledTableCell>{DateConverter(row.created_at)}</StyledTableCell>
                <StyledTableCell>{row.created_by}</StyledTableCell>
                <StyledTableCell>
                  {row.status === 'approved' ? (
                    <GreenChip title="Approved" />
                  ) : row.status === 'pending' ? (
                    <YellowChip title="Pending" />
                  ) : (
                    <RedChip title="Rejected" />
                  )}
                </StyledTableCell>
                <StyledTableCell>
                  <BasicMenu row={row} fetchData={fetchTableData} type="Engagement" />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationFooter
        tableData={tableData}
        page={currentPage}
        pagination={pagination}
        totalCount={totalCount}
        handleChangePage={handleChangePage}
      />
      {loading && <LoadingIcon />}
    </Box>
  );
}
